import { render, staticRenderFns } from "./Profiler.vue?vue&type=template&id=65eb3474&scoped=true"
import script from "./Profiler.vue?vue&type=script&lang=js"
export * from "./Profiler.vue?vue&type=script&lang=js"
import style0 from "./Profiler.vue?vue&type=style&index=0&id=65eb3474&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb3474",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSpinnerIos,QScrollArea,QSeparator});
